import styled from 'styled-components';
var ListItem = styled.li.withConfig({
  displayName: "ListItem",
  componentId: "sc-w8uiln-0"
})(["margin:0;padding:0;"]);

/** @component */
export default ListItem;